import { PdfCell } from './pdf-cell';

export class PdfRow {

    pdfCells: PdfCell[];

    constructor(pdfCells?: PdfCell[]) {
        this.pdfCells = [];
        if (pdfCells) {
            pdfCells.forEach(cell => this.pdfCells.push(cell));
        }
    }

    addCell(pdfCell: PdfCell) {
        this.pdfCells.push(pdfCell);
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-row.ts